// extracted by mini-css-extract-plugin
export var excerpt = "project-preview-module--excerpt--8TnMe";
export var externalUrls = "project-preview-module--externalUrls--1cpuF";
export var leadMediaThumb = "project-preview-module--leadMediaThumb--KD27D";
export var linkButton = "project-preview-module--linkButton--UIwDq buttons--button--OMEYV buttons--darkButton--Js567";
export var sectionTitle = "project-preview-module--sectionTitle--08fSK";
export var studentNavigation = "project-preview-module--studentNavigation--S1E3T";
export var studentNavigationLink = "project-preview-module--studentNavigationLink--Tz3XF";
export var title = "project-preview-module--title--8WlVP";